import { Component } from '@angular/core';

@Component({
  selector: 'app-adminuserlanding',
  templateUrl: './adminuserlanding.component.html',
  styleUrl: './adminuserlanding.component.scss'
})
export class AdminuserlandingComponent {

}
